import { Button, Modal } from 'antd'
import React, { useEffect } from 'react'
import { tourstartInterface } from './tourstart-interface'
import { RootState } from '../../../../store/store'
import { useDispatch, useSelector } from 'react-redux'
import { updateShowTourStart } from '../../../../store/appSlice/appSlice'

const Tourstart = ({ effectUpdateShowTour }: tourstartInterface) => {
	const dispatch = useDispatch()

	const state = useSelector((state: RootState) => ({
		user: state.user.user,
		showTourStart: state.app.showTourStart
	}))

	const { user, showTourStart } = state

	useEffect(() => {

		if (user?.doneOnboardingTour !== true) {
			dispatch(updateShowTourStart({
				showTourStart: true
			}))
		}

		// eslint-disable-next-line
	}, [user?.doneOnboardingTour])


	return (
		<div>
			<Modal
				onOk={() => {
					dispatch(updateShowTourStart({
						showTourStart: false
					}))
				}}
				onCancel={() => {
					dispatch(updateShowTourStart({
						showTourStart: false
					}))
				}}
				open={showTourStart}
				footer={null}
				title={null}
				closable={false}
				centered
				width={'35rem'}
				className='tour-modal'
			>
				<div>
					<div className='pt-[2.2rem] pb-[1.5rem]'>
						<div className='flex justify-center'>
							<img src="/img/vectors/biglily.svg" alt="" className='w-[9.2rem] h-[7.9rem]' />
						</div>

						<div className='px-[1.5rem] pt-10 pb-[0.5rem]'>
							<div className='mb-[0.5rem] border-b border-appcolorslightgrey pb-[0.5rem]'>
								<p className='text-appcolorfaintpurple text-[14px] mb-[0.5rem] leading-[17px]'
								>
									Start Tour
								</p>
								<p className='font-semibold text-appcolorblackfaint text-[18px] leading-[22px]'>
									Let’s get you started!
								</p>
							</div>

							<p className='text-appcolorpurplesix text-base mb-[1.2rem]'>
								{
									user?.userType === 'student' ?
									<>
									Let’s kick off your coding adventure with a quick tour on how to use Code Funhouse to improve your coding skills and become a champ.
									</>
									:
									<>
									Empower your students coding career with a quick tour on how to use Code Funhouse to revolutionise your teaching experience. 
									</>
								}
								
							</p>

							<div>
								<Button
									className='custom-primary-one-btn white-text smaller-border-radius smaller-padding'
									onClick={() => {
										effectUpdateShowTour(true)
										dispatch(updateShowTourStart({
											showTourStart: false
										}))
									}}
								>
									Start
								</Button>

								<Button
									className='ml-[1.4rem] custom-grey-btn black-text smaller-border-radius smaller-padding'
									onClick={() => {
										dispatch(updateShowTourStart({
											showTourStart: false
										}))
									}}
								>
									Skip Tour
								</Button>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		</div>
	)
}

export default Tourstart